var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$canShowFeature("rebate")
    ? _c("div", { staticClass: "design-daily-roii" }, [
        _c("div", { staticClass: "design-daily-roii__hero" }, [
          _c("div", {
            staticClass: "design-daily-roii__hero-bg",
            style: { backgroundImage: "url(" + _vm.roiiHeroBg + ")" },
          }),
          _c("span", { staticClass: "design-daily-roii__hero-title" }, [
            _vm._v("每日ROLL"),
          ]),
        ]),
        _c("div", { staticClass: "design-daily-roii__cards" }, [
          _c(
            "div",
            { staticClass: "design-daily-roii__scroll" },
            [
              _vm.roiiListLoading
                ? _vm._l(6, function (n) {
                    return _c(
                      "div",
                      {
                        key: "skeleton-" + n,
                        staticClass:
                          "design-daily-roii__card design-daily-roii__card--skeleton",
                      },
                      [
                        _vm._m(0, true),
                        _vm._m(1, true),
                        _vm._m(2, true),
                        _vm._m(3, true),
                      ]
                    )
                  })
                : _vm._l(_vm.roiiList, function (item, i) {
                    return _c(
                      "div",
                      {
                        key:
                          item.item && item.item.itemPic
                            ? i + "-" + item.createTime
                            : i,
                        staticClass: "design-daily-roii__card",
                        class: {
                          "design-daily-roii__card--clickable": item.id,
                        },
                        on: {
                          click: function ($event) {
                            item.id &&
                              _vm.$router.push({
                                name: "rollDetail",
                                params: { id: item.id },
                              })
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "card-top" }, [
                          _c("span", { staticClass: "date" }, [
                            _vm._v(_vm._s(item.createTime || "--")),
                          ]),
                          _c("span", { staticClass: "pill pill--num" }, [
                            _c(
                              "svg",
                              {
                                staticStyle: { "margin-right": "6px" },
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "17",
                                  height: "17",
                                  viewBox: "0 0 17 17",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M2.61554 5.54495C3.08337 4.99645 3.92043 5.11824 4.5007 5.40876C4.83618 5.58375 5.25006 5.45462 5.42676 5.1194C5.60378 4.78321 5.47487 4.36707 5.13904 4.18989L5.13801 4.18934C3.99365 3.58928 2.45637 3.6121 1.56985 4.65131C0.807727 5.54463 0.90228 6.93865 1.55335 7.99971C2.23981 9.11813 3.57493 9.97955 5.49998 9.97955C5.87983 9.97955 6.18747 9.67156 6.18747 9.29151C6.18747 8.9115 5.87983 8.60344 5.49998 8.60344C4.01772 8.60344 3.14319 7.96117 2.72485 7.27948C2.27143 6.54033 2.36562 5.83766 2.61554 5.54495ZM13.8845 5.54495C13.4166 4.99645 12.5796 5.11824 11.9993 5.40876C11.6638 5.58375 11.2499 5.45462 11.0732 5.1194C10.8962 4.78321 11.0251 4.36707 11.361 4.18989L11.362 4.18934C12.5064 3.58928 14.0436 3.6121 14.9302 4.65131C15.6923 5.54463 15.5977 6.93865 14.9467 7.99971C14.2602 9.11813 12.9251 9.97955 11 9.97955C10.6202 9.97955 10.3125 9.67156 10.3125 9.29151C10.3125 8.9115 10.6202 8.60344 11 8.60344C12.4823 8.60344 13.3568 7.96117 13.7751 7.27948C14.2286 6.54033 14.1344 5.83766 13.8845 5.54495ZM9.12934 10.3233H7.37067L6.93583 12.589C6.88015 12.8788 6.64193 13.1015 6.34354 13.1431L5.11945 13.3139C4.67633 13.3758 4.32158 13.7038 4.23393 14.1324L4.13354 14.6219C4.07924 14.8877 4.2872 15.1359 4.56496 15.1359H11.935C12.2128 15.1359 12.4208 14.8877 12.3665 14.6219L12.2661 14.1324C12.1784 13.7038 11.8237 13.3758 11.3806 13.314L10.1565 13.1431C9.85808 13.1015 9.61989 12.8788 9.56417 12.589L9.12934 10.3233Z",
                                    fill: "#FF934A",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M4.41775 9.17684C4.70444 10.831 6.17468 12.0421 7.89655 12.0421H8.60327C10.3251 12.0421 11.7954 10.831 12.0821 9.17684L12.7077 5.56704C12.7935 5.07259 12.9478 4.59253 13.1663 4.14076L13.5846 3.27451C13.9789 2.45773 13.6568 1.6751 12.7366 1.57101C11.8466 1.47034 10.4455 1.38574 8.24991 1.38574C6.05435 1.38574 4.65323 1.47034 3.76323 1.57104C2.843 1.67514 2.5209 2.45773 2.91519 3.27454L3.33355 4.14076C3.55204 4.59253 3.70639 5.07259 3.79214 5.56704L4.41775 9.1768V9.17684Z",
                                    fill: "#FCBF28",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M7.86012 3.68636C8.02409 3.36887 8.47578 3.36887 8.63975 3.68636L9.17052 4.715L10.3014 4.93885C10.6359 5.00501 10.771 5.41229 10.5431 5.66704L9.73941 6.56561L9.88653 7.76451C9.92952 8.11397 9.56823 8.37075 9.25473 8.21352L8.24993 7.7094L7.24514 8.21352C6.93164 8.37075 6.57035 8.11394 6.61334 7.76451L6.76046 6.56561L5.95676 5.66704C5.72885 5.41229 5.86394 5.00501 6.19842 4.93885L7.32935 4.715L7.86012 3.6864V3.68636Z",
                                    fill: "#7E6434",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" " + _vm._s(item.quantity || 0) + " "),
                          ]),
                        ]),
                        item.item && item.item.itemPic
                          ? _c("div", { staticClass: "card-img" }, [
                              _c("img", {
                                attrs: {
                                  src: _vm._f("imgfilter")(item.item.itemPic),
                                  alt: "",
                                },
                              }),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "card-desc" }, [
                          _vm._v(
                            _vm._s(
                              item.item && item.item.rarity != null
                                ? item.item.rarity
                                : "--"
                            ) +
                              " | " +
                              _vm._s(
                                _vm._f("GetItemName")(
                                  item.item && item.item.name
                                )
                              ) +
                              " | " +
                              _vm._s(
                                _vm._f("GetItemSkinName")(
                                  item.item && item.item.name
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "card-bottom" }, [
                          _c("span", { staticClass: "pill" }, [
                            _c("img", {
                              staticClass: "icon",
                              attrs: {
                                src: require("@/assets/images/home_new/KJ_currency.png"),
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s((item.item && item.item.sellPrice) || 0)
                            ),
                          ]),
                          _c("span", { staticClass: "pill pill--time" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "9",
                                  height: "10",
                                  viewBox: "0 0 9 10",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M8.74359 2.65116C8.89744 2.39535 9 2.09302 9 1.76744C9 0.790698 8.1282 0 7.07692 0C6.46154 0 5.89744 0.27907 5.5641 0.674419C6.8718 0.953488 8 1.65116 8.74359 2.65116ZM3.46154 0.697674C3.10256 0.27907 2.5641 0.0232559 1.92308 0.0232558C0.871795 0.0232558 0 0.790698 0 1.76744C0 2.09302 0.102564 2.37209 0.25641 2.65116C1 1.65116 2.12821 0.953488 3.46154 0.697674ZM4.51282 1.23256C2.15385 1.23256 0.230769 3.25 0.230769 5.38953C0.230769 7.52907 2.14103 9.75 4.5 9.75C6.85897 9.75 8.79487 7.52907 8.79487 5.38953C8.76923 3.25 6.87179 1.23256 4.51282 1.23256ZM6.53846 5.85465H4.10256V2.67442H4.71795V5.25H6.51282V5.85465H6.53846Z",
                                    fill: "white",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" " + _vm._s(item.timeText || "--") + " "),
                          ]),
                        ]),
                      ]
                    )
                  }),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-top" }, [
      _c("span", {
        staticClass: "roii-skeleton-line roii-skeleton-line--date",
      }),
      _c("span", {
        staticClass: "roii-skeleton-line roii-skeleton-line--pill",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-img" }, [
      _c("div", { staticClass: "roii-skeleton-line roii-skeleton-line--img" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-desc" }, [
      _c("span", {
        staticClass: "roii-skeleton-line roii-skeleton-line--desc",
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-bottom" }, [
      _c("span", {
        staticClass: "roii-skeleton-line roii-skeleton-line--pill",
      }),
      _c("span", {
        staticClass: "roii-skeleton-line roii-skeleton-line--pill",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }